import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-flex align-center" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", null, "사원정보삭제", -1)

import axios from "axios";

export default /*#__PURE__*/_defineComponent({
  __name: 'AdminEmpDelete',
  props: {
  item: {
    type: Object,
    required: true,
  },
},
  emits: ["success"],
  setup(__props, { emit: __emit }) {

const emit = __emit;
const props = __props;
const deleteEmp = async () => {
  try {
    const isConfirmed = window.confirm(
      "정말 삭제하시겠습니까? 삭제 시 퇴사자 반영이 되지 않습니다."
    );
    if (isConfirmed) {
      const code = props.item.sisul_code;
      const empNum = props.item.emp_num;
      const response = await axios.post(`/api/deleteEmp/${code}/${empNum}`);
      const result = response.data;
      if (result.success === true) {
        alert("사원정보 삭제가 완료되었습니다.");
        emit("success");
      } else {
        alert("사원정보 삭제에 실패하였습니다. 관리자에게 문의해주세요.");
      }
    } else {
      return;
    }
  } catch (error) {
    alert("사원정보 삭제작업을 처리할 수 없습니다.");
    console.error(error);
  }
};

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_v_icon, {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (deleteEmp())),
      color: "blue-grey-darken-2",
      size: "large",
      style: {"padding-bottom":"3px"}
    }, {
      default: _withCtx(() => [
        _createTextVNode("mdi-delete")
      ]),
      _: 1
    })
  ]))
}
}

})